import Vue from 'vue'
import axios from 'axios'
import App from './App'
import router from './router'
import Element from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import VueVideoPlayer from 'vue-video-player'
import store from './store'
// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

import '../theme/index.css'

console.log(1)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.globalData = {} // 定义一个全局变量
Vue.use(VueVideoPlayer, {
  // options: global default options,
  // events: global videojs events
})
Vue.use(VueClipboard)
Vue.use(Element, { size: 'big' })

window.app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
